import { useMantineTheme } from '@mantine/core';
import { IconAt, IconExclamationCircle, IconMail, IconSend } from '@tabler/icons-react';
import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import { Fragment } from 'react';
import styleIdentifiers from './RecoveryPlan.module.scss';
import type { RecoveryPlanStepLineProps } from './RecoveryPlanStep.types';

const styles = classNames.bind(styleIdentifiers);

export const RecoveryPlanStepTaskLine = ({ index, step, editStep }: RecoveryPlanStepLineProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const { sending_media, template, fee_step_reached: isFeeStepReached, task_attributes } = step;

  return (
    <div className={styles('step-template')}>
      <div className={styles('template')}>
        <div className={styles('template-name')}>
          {template ? template.name : task_attributes?.title}
        </div>
        <div className={styles('template-type')}>
          {t(
            template
              ? (i18nKeys.TEMPLATE_TYPES as any)[template.step_type.toUpperCase()]
              : i18nKeys.TASK_GENERATION,
          )}
        </div>
        {isFeeStepReached && (
          <div className={styles('late-fees')}>{t(i18nKeys.LATE_FEES_INCLUDED)}</div>
        )}
      </div>
      {template ? (
        <div className={styles('actions')} onClick={editStep && editStep!(index)}>
          {sending_media.map(({ name, force_sending }, i) =>
            i === 0 ? (
              <div className={styles('action')} key={`${name}-${i}`}>
                {name === 'email' ? (
                  <IconAt color={theme.colors.gray[6]} size={24} stroke={1.5} />
                ) : (
                  <IconSend color={theme.colors.gray[6]} size={24} stroke={1.5} />
                )}
              </div>
            ) : (
              <Fragment key={`${name}-${i}`}>
                <span>{t(String(force_sending) === 'true' ? i18nKeys.AND : i18nKeys.OR)}</span>
                <div className={styles('action')}>
                  {name === 'email' ? (
                    <IconMail color={theme.colors.gray[6]} size={24} stroke={1.5} />
                  ) : (
                    <IconSend color={theme.colors.gray[6]} size={24} stroke={1.5} />
                  )}
                </div>
              </Fragment>
            ),
          )}
        </div>
      ) : (
        task_attributes?.mandatory === 'true' && (
          <div className={styles('action', 'red')} title={t(i18nKeys.TASK.ATTRIBUTES.MANDATORY)}>
            <IconExclamationCircle color={theme.colors.red[7]} size={24} stroke={1.5} />
          </div>
        )
      )}
    </div>
  );
};
